export const resetedLineHeight = '1em'

export const textFontWeights = {
  regular: 400,
  medium: 500,
  bold: 700,
  black: 900,
}

export const textFontSizes = {
  header: {
    sm: 20,
    sm1: 20,
    md: 24,
    md1: 24,
    lg: 32,
    xl: 40,
    xl1: 40,
  },
  par: {
    sm: 12,
    md: 14,
    lg: 17,
    xl: 20,
  },
}

export const textLineHeights = {
  header: {
    sm: 24,
    sm1: 28,
    md: 28,
    md1: 32,
    lg: 36,
    xl: 44,
    xl1: 48,
  },
  par: {
    sm: 16,
    md: 20,
    lg: 24,
    xl: 24,
  },
}
